import { Injectable, Output, EventEmitter } from '@angular/core';
import { FacingModes } from '@app/components/image-capture2/image-capture2.component';
import { CaptureMode } from '@app/types/Types';

@Injectable({ providedIn: 'root' })
export class ImageCaptureService {
  @Output() startCapture: EventEmitter<CaptureMode> = new EventEmitter<CaptureMode>()
  @Output() imageCaptured: EventEmitter<string> = new EventEmitter<string>()
  @Output() imageApproved: EventEmitter<string> = new EventEmitter<string>()
  @Output() imageDeclined: EventEmitter<null> = new EventEmitter<null>()
  @Output() setInstructionText: EventEmitter<string> = new EventEmitter<string>()
  @Output() setFacingMode: EventEmitter<FacingModes> = new EventEmitter<FacingModes>()
  @Output() releaseCamera: EventEmitter<null> = new EventEmitter<null>()
  @Output() processFinished: EventEmitter<null> = new EventEmitter<null>()
  constructor() {


  }

}
